import React, { useState } from "react";
import { Button } from "antd";
import { hover } from "framer-motion";

const CustomButton = ({
  buttonType,
  variant,
  buttonText,
  className,
  onClick,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const buttonStyles = {
    cancel: {
      color: "#06513D",
      background: "#E6EDEB",
      border: "1px solid #06513D",
      fontFamily: "Calibri, sans-serif",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "100%",
      letterSpacing: "0%",
    },

    ok: {
      background: "#06513D",
      color: "#fff",
    },
  };

  const handleClick = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      await onClick();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type={buttonType}
      onClick={handleClick}
      disabled={isLoading}
      loading={isLoading} // Adds loader icon
      style={buttonStyles[variant]}
      className={`font-light px-4 py-2 ${variant === "ok" ? "hover:!bg-[#387464] text-[#06513D] hover:!text-[#E6EDEB]" : "hover:!bg-[#F8F8F8]  hover:!text-[#06513D]"} ${className}`}
    >
      {buttonText}
    </Button>
  );
};

export default CustomButton;
